import * as Stimulus from "@hotwired/stimulus"
import IMask from "imask"

export class MaskedInputController extends Stimulus.Controller {
    static values = {
        mask: String
    }

    connect() {
        this.mask = IMask(this.element, { mask: this.maskValue, lazy: false });
        this.mask.on("accept", () => this.updateValidity());
        this.updateValidity();
    }

    disconnect() {
        this.mask.destroy();
    }

    updateValidity() {
        if (this.element.required) {
            this.element.setCustomValidity(
                this.mask.masked.isComplete ? "" : "Please fill out this field."
            );
        }
    }
}
